import React from 'react';
import './styles.css';

const WarningDimensions = props => {
    return (
        <div className="warningDimensionsCont">
            <h1>Lo sentimos, este sitio no se encuentra disponible para utilizar en versión Teléfono/Tablet</h1>
            <h2>Si desea hacerlo, descarguese la app disponible en Playstore: <a href="https://play.google.com/store/apps/details?id=com.autosolve.sadeapp" target="_blanck">Grupo SADE</a></h2>
        </div>
    );
};

WarningDimensions.propTypes = {
    
};

export default WarningDimensions;